import { useMemo } from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { Link } from 'react-router-dom';
import { generateTopicUrl } from '../../lib/urlUtils';
import { useAgenda } from '../../hooks/useAgenda';
import { useAdmin } from '../../contexts/AdminContext';

export function AgendaCloud() {
    const { agenda, isLoading, error } = useAgenda();
    const { settings } = useAdmin();

    // Client-side randomization from the pool of 30
    const randomTopics = useMemo(() => {
        if (!agenda || agenda.length === 0) return [];
        return [...agenda]
            .sort(() => 0.5 - Math.random())
            .slice(0, 8);
    }, [agenda]);

    if (!settings.features.eksiAgenda) return null;
    if (error && !agenda.length) return null;

    return (
        <div className="mb-10">
            <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-2">
                    <Flame className="w-5 h-5 text-mavi-500" />
                    <h3 className="font-poppins font-semibold text-xl text-gray-900 dark:text-white">
                        gündem
                    </h3>
                    <span className="text-[10px] bg-surface-100 dark:bg-surface-800 text-gray-500 dark:text-gray-400 px-2 py-0.5 rounded-full font-medium ml-1">
                        bugün
                    </span>
                </div>
            </div>

            {isLoading && agenda.length === 0 ? (
                <div className="flex flex-wrap gap-2 animate-pulse">
                    {[...Array(6)].map((_, i) => (
                        <div key={i} className="h-9 bg-surface-100 dark:bg-surface-800 rounded-full w-24" />
                    ))}
                </div>
            ) : (
                <div className="flex flex-nowrap lg:flex-wrap gap-2.5 overflow-x-auto lg:overflow-visible hide-scrollbar pb-2 -mx-4 px-4 lg:mx-0 lg:px-0">
                    {randomTopics.map((topic, index) => (
                        <div key={topic} className="flex-shrink-0 lg:flex-shrink">
                            <motion.div
                                initial={{ opacity: 0, scale: 0.9 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: index * 0.05 }}
                            >
                                <Link
                                    to={generateTopicUrl(topic, topic)}
                                    className="inline-flex items-center px-4 py-2 bg-white dark:bg-surface-900 hover:bg-mavi-500 hover:text-white dark:hover:bg-mavi-600 border border-surface-200 dark:border-surface-700 hover:border-mavi-500 dark:hover:border-mavi-600 rounded-full text-sm font-poppins font-medium text-gray-700 dark:text-gray-300 transition-all duration-200 hover:shadow-lg hover:shadow-mavi-500/10 active:scale-95 shadow-sm whitespace-nowrap"
                                >
                                    {topic}
                                </Link>
                            </motion.div>
                        </div>
                    ))}

                    {agenda.length === 0 && !isLoading && (
                        <p className="text-sm text-gray-500 dark:text-gray-400 italic">
                            Şu an için gündem başlığı bulunamadı.
                        </p>
                    )}
                </div>
            )}
        </div>
    );
}
